export default __webpack_public_path__ + "static/media/senior-sample4.9d93ef35.png";